const textDecoder = new TextDecoder()

export default textDecoder
